module.exports = ".Button_align {\r\ntext-align:center;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/member-billing-info/add-credit/add-credit.component.css
// module id = ./src/app/shared/components/member-billing-info/add-credit/add-credit.component.css
// module chunks = main